$(function () {
    // Mostrar los PopUps
    const modalBannerPopup = $('#modalBannerPopup');

    if (modalBannerPopup.length) {
        modalBannerPopup[0].addEventListener('shown.bs.modal', function () {
            const $slider = $(this).find('.slider.slick-initialized');
            if ($slider.length) {
                $slider.slick('setPosition');
            }
        });
        new bootstrap.Modal(modalBannerPopup).show();
    }
});
